import React from 'react';
import Button from '../../../../components/base/Button';

const HormoneHero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-purple-50" 
             style={{
               backgroundImage: `url('https://public.readdy.ai/ai/img_res/c7f145f493b3f2ef93fa9c1afaa2cc7f.jpg')`,
               backgroundSize: 'cover',
               backgroundPosition: 'center'
             }}>
      <div className="absolute inset-0 bg-white/80"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center">
              <i className="ri-heart-pulse-line text-3xl text-white"></i>
            </div>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-gray-900 mb-8">
            Bioidentical <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600">Hormone Optimization</span>
          </h1>
          
          <p className="text-xl sm:text-2xl text-gray-600 mb-12 leading-relaxed">
            Restore your vitality and reclaim your life with personalized bioidentical hormone replacement therapy. 
            Our cutting-edge protocols help you achieve optimal hormonal balance for enhanced energy, mood, and overall wellness.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-12">
            <Button variant="primary" size="lg" className="bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700">
              <i className="ri-calendar-check-line mr-2"></i>
              Schedule Consultation
            </Button>
            <Button variant="outline" size="lg">
              <i className="ri-download-line mr-2"></i>
              Download Treatment Guide
            </Button>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold text-pink-600 mb-2">95%</div>
              <div className="text-gray-600">Patient Satisfaction</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-purple-600 mb-2">2-4 weeks</div>
              <div className="text-gray-600">To Feel Results</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-pink-600 mb-2">10+ years</div>
              <div className="text-gray-600">Clinical Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HormoneHero;